module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-size"
  }, [(_vm.displaySize || _vm.displaySize === 0) ? [_c('svg-icon', {
    attrs: {
      "icon": _vm.audience,
      "width": 56,
      "height": 33
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "h2 mt-5"
  }, [_vm._v(_vm._s(_vm._f("truncateAmount")(_vm.displaySize)))]), _vm._v(" "), _c('div', {
    staticClass: "subtitle-1 audience-size__text"
  }, [_vm._v("Target Audience (Age 18+)")]), _vm._v(" "), _c('viewership-time-frame', {
    attrs: {
      "validStreamingOptions": _vm.validStreamingOptions,
      "selectedViewshipOption": _vm.viewershipOption
    },
    on: {
      "selected": _vm.onSelectedViewingStream
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32374adb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/lasGraphs/audienceSize/components/AudienceSize.vue
// module id = 1851
// module chunks = 0